import * as React from 'react'
import { styled } from 'next-yak'

import * as S from '../../styles'

export type ActionButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string
  /** @default false */
  active?: boolean
  contents: {
    inactive: React.ReactNode
    inactiveHover?: React.ReactNode
    active: React.ReactNode
    activeHover?: React.ReactNode
  }
  noShadow?: boolean
}

function ActionButtonComponent({
  className,
  active = false,
  contents,
  ...buttonProps
}: ActionButtonProps): React.ReactElement<ActionButtonProps> {
  const [hover, setHover] = React.useState(false)
  const [realActive, setRealActive] = React.useState(active)
  const [realHover, setRealHover] = React.useState(hover)

  React.useEffect(() => {
    setRealActive(active)
    setRealHover(hover)
  }, [hover])

  React.useEffect(() => {
    setRealActive(active)
    setRealHover(false)
  }, [active])

  return (
    <S.button.ActionButton
      className={className}
      $active={realActive}
      $hover={realHover}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...buttonProps}
    >
      {getContent()}
    </S.button.ActionButton>
  )

  function getContent(): React.ReactNode {
    return realHover && realActive
      ? contents.activeHover || contents.active
      : !realHover && realActive
        ? contents.active
        : realHover && !realActive
          ? contents.inactiveHover || contents.inactive
          : !realHover && !realActive
            ? contents.inactive
            : undefined
  }
}

export const ActionButton = styled(ActionButtonComponent)<ActionButtonProps>``
ActionButton.displayName = 'ActionButton'
